import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { FootPrintApiManager_DatasourceService } from './FootPrintApiManager.datasource.index';

import { app_custom_ds_get_licenseplates_by_lookupcode_and_warehouseIdService } from './app.datasource.index';

@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
    this.FootPrintApiManager = this.injector.get(FootPrintApiManager_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
    public FootPrintApiManager: FootPrintApiManager_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _custom_ds_get_licenseplates_by_lookupcode_and_warehouseId: app_custom_ds_get_licenseplates_by_lookupcode_and_warehouseIdService;
  public get custom_ds_get_licenseplates_by_lookupcode_and_warehouseId(): app_custom_ds_get_licenseplates_by_lookupcode_and_warehouseIdService {
    if(!this._custom_ds_get_licenseplates_by_lookupcode_and_warehouseId) {
      this._custom_ds_get_licenseplates_by_lookupcode_and_warehouseId = this.injector.get(app_custom_ds_get_licenseplates_by_lookupcode_and_warehouseIdService);
    }
    return this._custom_ds_get_licenseplates_by_lookupcode_and_warehouseId;
  }
}

